
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 29549","d":"M0 0h26v26H0z","fill":"none"}}),_c('path',{attrs:{"data-name":"Path 29550","d":"M2.294 9.86v6.278h4.56l5.7 5.232V4.629l-5.7 5.231zm15.39 3.139a4.689 4.689 0 00-2.85-4.216v8.423a4.663 4.663 0 002.85-4.207zm-2.85-9.176v2.155a7.443 7.443 0 015.7 7.021 7.443 7.443 0 01-5.7 7.021v2.155a9.631 9.631 0 007.98-9.176 9.631 9.631 0 00-7.98-9.176z","fill":"#757575"}})])
          )
        }
      }
    